import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ['modal', 'form'];
  }

  static get values() {
    return { url: String };
  }

  load() {
    fetch(this.urlValue, {"credentials": "same-origin"}).
      then(response => response.text()).
      then(html => {
        // Server-rendered HTML from our own action, same-origin, Rails-escaped:
        // Subdomain::Gifts::ResendsController#new (subdomain/gifts/resends/v2/new.html.haml).
        this.modalTarget.innerHTML = html
      })
  }

  submitForm(event) {
    event.preventDefault()

    let url = this.formTarget.action;
    fetch(url, {
      "credentials": "same-origin",
      "method": "POST",
      "body": new FormData(this.formTarget)
    }).
      then(response => response.text()).
      then(html => {
        if (html.length === 0) {
          location.reload();
        } else {
          // Server-rendered HTML from our own action, same-origin, Rails-escaped:
          // Subdomain::Gifts::ResendsController#create re-rendering :new on validation
          // failure (subdomain/gifts/resends/new.html.haml).
          this.modalTarget.innerHTML = html
        }
      })
  }
}
